<template>
  <div class="T">
    <!-- 电脑端：保持不变 -->
    <div class="addr-desktop">
      <el-form>
        <el-form-item>
          <el-input clearable :placeholder="('请搜索关键字查询')" v-model.trim="cxyts.search_content" @clear="QingChu"></el-input>
          
        </el-form-item>
        <el-form-item :label="$t('waterMeter.小区') + ':'" class="elform">
          <el-select v-model="cxyts.community_id" :placeholder="$t('waterMeter.请选择小区')" size="small" @change="selectQuarters(cxyts.community_id)">
            <el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.楼栋') + ':'" class="elform">
          <el-select v-model="cxyts.building_id" :placeholder="$t('waterMeter.请选择楼栋')" size="small" @change="selectBuildings(cxyts.building_id)">
            <el-option v-for="item in Buildings" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.单元') + ':'" class="elform">
          <el-select v-model="cxyts.unit_id" :placeholder="$t('waterMeter.请选择单元')" size="small" @change="selectunit(cxyts.unit_id)">
            <el-option v-for="item in units" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.房间') + ':'" class="elform">
          <el-select v-model="cxyts.room_id" :placeholder="$t('waterMeter.请选择房间')" size="small" @change="selectroom(cxyts.room_id)">
            <el-option v-for="item in roomsfas" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="elfomobtn" type="primary" @click="pay_search">{{ $t('waterMeter.查询') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="elfomobtn" type="primary" @click="shuaxin">{{ $t('waterMeter.重选') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 手机端：按你给的 62-119 结构布局（仅小屏显示） -->
    <div class="addr-mobile">
      <!-- 搜索 -->
      <el-form class="addr-m-search">
        <el-form-item class="addr-m-search-item">
          <el-input class="addr-m-input" clearable :placeholder="('请搜索关键字查询')" v-model.trim="cxyts.search_content" @clear="QingChu"></el-input>
          <el-button class="formBtn addr-m-btn" type="primary" @click="pay_search">{{ $t('waterMeter.查询') }}</el-button>
          <el-button class="formBtn addr-m-btn" type="primary" @click="shuaxin">{{ $t('waterMeter.重选') }}</el-button>
        </el-form-item>
      </el-form>

      <el-form class="addr-m-grid">
        <el-form-item :label="$t('waterMeter.小区') + ':'" class="elform addr-m-cell">
          <el-select
            v-model="cxyts.community_id"
            :placeholder="$t('waterMeter.请选择小区')"
            size="small"
            popper-class="addr-m-select-popper"
            :popper-append-to-body="true"
            @change="selectQuarters(cxyts.community_id)">
            <el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.楼栋') + ':'" class="elform addr-m-cell">
          <el-select
            v-model="cxyts.building_id"
            :placeholder="$t('waterMeter.请选择楼栋')"
            size="small"
            popper-class="addr-m-select-popper"
            :popper-append-to-body="true"
            @change="selectBuildings(cxyts.building_id)">
            <el-option v-for="item in Buildings" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-form class="addr-m-grid">
        <el-form-item :label="$t('waterMeter.单元') + ':'" class="elform addr-m-cell">
          <el-select
            v-model="cxyts.unit_id"
            :placeholder="$t('waterMeter.请选择单元')"
            size="small"
            popper-class="addr-m-select-popper"
            :popper-append-to-body="true"
            @change="selectunit(cxyts.unit_id)">
            <el-option v-for="item in units" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.房间') + ':'" class="elform addr-m-cell">
          <el-select
            v-model="cxyts.room_id"
            :placeholder="$t('waterMeter.请选择房间')"
            size="small"
            popper-class="addr-m-select-popper"
            :popper-append-to-body="true"
            @change="selectroom(cxyts.room_id)">
            <el-option v-for="item in roomsfas" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['reload'],
  data () {
    return {
      // 下拉框
      // 获取小区
      quarters: [{
        id: null,
        name: null
      }],
      // 获取楼栋
      Buildings: [{
        id: null,
        name: null
      }],
      // 获取单元
      units: [{
        id: null,
        name: null
      }],
      // 获取房间
      roomsfas: [{
        id: null,
        name: null
      }],
      // 小区参数
      comities: {
        token: null
      },
      munity: null,
      // 楼栋参数
      buings: {
        token: null,
        community_id: null
      },
      unis: null,
      // 单元参数
      unistfs: {
        token: null,
        building_id: null
      },
      rom: null,
      // 房间参数
      roomfs: {
        token: null,
        unit_id: null
      },
      zaisns: [{
        id: 1,
        name: null
      }],
      cxyts: {
        project_id: null,
        token: null,
        pay_id: null,
        search_content: null,
        location_id: null,
        insufficient_balance: null,
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null
      },
      parData: [],
      tableData: [],
      _addrMobileTouchSelectHandler: null
    }
  },
  created () {
    // 下拉框
    // 获取小区
    this.residential()
    // 获取楼栋
    this.Building()
    // 单元
    this.unit()
    // 房间
    this.room()
  },
  mounted () {
    // 仅手机端：修复部分 iOS/内置浏览器下拉项“需点两次才选中”
    try {
      const isMobile = window && window.matchMedia && window.matchMedia('(max-width: 768px)').matches
      if (!isMobile) return

      this._addrMobileTouchSelectHandler = (e) => {
        const target = e && e.target
        if (!target || !target.closest) return
        const item = target.closest('.addr-m-select-popper .el-select-dropdown__item')
        if (!item) return
        if (item.classList.contains('is-disabled')) return

        // 阻止“第一次仅 hover/聚焦”的触摸行为，直接触发 click 选中
        e.preventDefault()
        e.stopPropagation()
        item.click()
      }

      document.body.addEventListener('touchend', this._addrMobileTouchSelectHandler, { passive: false })
    } catch (err) {
      // ignore
    }
  },
  beforeDestroy () {
    if (this._addrMobileTouchSelectHandler) {
      document.body.removeEventListener('touchend', this._addrMobileTouchSelectHandler)
      this._addrMobileTouchSelectHandler = null
    }
  },
  props: ['getname'],
  methods: {
    // 输入框清除
    QingChu () {
      console.log('112')
      this.reload()
    },
    // 查询
    pay_search () {
      this.cxyts.project_id = this.$store.state.print.goodsForeNo.project_id
      this.cxyts.token = this.$store.state.print.goodsForeNo.token
      this.$api.userProfile.Czhixios(this.cxyts).then((res) => {
        this.tableData = res.data
        console.log(this.tableData, '查询')
        // this.tableData = res.data.data
        // this.total = res.data.total
        this.getname(this.tableData)
      })
    },
    // 刷新
    shuaxin () {
      this.reload()
    },
    // 获取小区
    residential () {
      this.comities.token = this.$store.state.print.goodsForeNo.token
      this.$api.userProfile.communities(this.comities).then((res) => {
        console.log(res.data.data, '获取小区')
        this.quarters = res.data.data
      })
    },
    selectQuarters (val) {
      console.log(val, 'val')
      this.munity = val
      this.$emit('transfer', this.munity)
      this.cxyts.building_id = null
      this.cxyts.unit_id = null
      this.cxyts.room_id = null
      this.Building()
      this.cxyts.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.getmeterTable(this.cxyts).then((res) => {
        console.log(res, '查询')
        this.parData = res
        this.$emit('ParData', this.parData)
      })
    },
    // 获取楼栋
    Building () {
      this.buings.token = this.$store.state.print.goodsForeNo.token
      this.buings.community_id = this.munity
      this.$api.userProfile.buildings(this.buings).then((res) => {
        console.log(res.data.data, '获取楼栋')
        this.Buildings = res.data.data
      })
    },
    selectBuildings (val) {
      console.log(val, 'val2')
      this.unis = val
      this.$emit('Building', this.unis)
      this.cxyts.unit_id = null
      this.cxyts.room_id = null
      this.unit()
      this.cxyts.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.getmeterTable(this.cxyts).then((res) => {
        console.log(res, '查询')
        this.parData = res
        this.$emit('buildingData', this.parData)
      })
    },
    // 单元
    unit () {
      this.unistfs.token = this.$store.state.print.goodsForeNo.token
      this.unistfs.building_id = this.unis
      this.$api.userProfile.units(this.unistfs).then((res) => {
        console.log(res.data.data, '获取单元')
        this.units = res.data.data
      })
    },
    selectunit (val) {
      console.log(val, 'val3')
      this.rom = val
      this.$emit('unit', this.rom)
      this.cxyts.room_id = null
      this.room()
      this.cxyts.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.getmeterTable(this.cxyts).then((res) => {
        console.log(res, '查询')
        this.parData = res
        this.$emit('unitData', this.parData)
      })
    },
    // 房间
    room () {
      this.roomfs.token = this.$store.state.print.goodsForeNo.token
      this.roomfs.unit_id = this.rom
      this.$api.userProfile.rooms(this.roomfs).then((res) => {
        console.log(res.data.data, '获取房间')
        this.roomsfas = res.data.data
      })
    },
    selectroom (val) {
      console.log(val, '房间id')
      this.$emit('room', val)
      this.cxyts.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.getmeterTable(this.cxyts).then((res) => {
        console.log(res, '查询')
        this.parData = res
        this.$emit('roomData', this.parData)
      })
    }
  }
}

</script>

<style lang="less" scoped>

// 搜索
    .addr-mobile{
      display: none;
    }

    .addr-desktop .el-form{
      display: flex;
      flex-wrap: wrap;
      .el-input {
      border-radius: 6px;
      width: 200px;
    }
    .el-button {
      margin-left: 10px;
      background-color: #744dfe;
      border: 0px;
    }
    }
  .addr-desktop .el-form-item{
      display: flex;
      margin-top: 20px;
    .el-select{
      width: 150px;
    }
  }
  .addr-desktop .elform{
    margin-left: 20px;
  }
  // 移动端
  @media (min-width: 768px) {
    .formBtn{
      display: none;
    }
    }
  @media (max-width: 768px) {
    .addr-desktop{
      display: none;
    }
    .addr-mobile{
      display: block;
      width: 100%;
      /* 减轻移动端双击缩放/300ms 延迟对下拉项的影响 */
      touch-action: manipulation;
      -webkit-tap-highlight-color: transparent;
    }

    /* 手机端搜索行：输入+按钮不换行，自适应缩小 */
    .addr-m-search .el-form-item{
      margin-top: 0px;
      margin-bottom: 6px;
    }
    .addr-m-search-item ::v-deep .el-form-item__content{
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 6px;
      width: 100%;
      margin-left: 0 !important;
    }
    .addr-m-input{
      flex: 1 1 auto;
      min-width: 0;
    }
    /* iOS：输入框字体 <16px 聚焦会整页放大，手机端统一16px */
    .addr-m-input ::v-deep .el-input__inner{
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      padding: 0 10px;
    }
    .addr-m-btn{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      margin-left: 0 !important;
      background-color: #744DFE;
      border: none;
      padding: 7px 10px;
      min-height: 32px;
      font-size: 12px;
      line-height: 1;
      color: #fff !important;
    }
    .addr-m-btn:hover,
    .addr-m-btn:focus,
    .addr-m-btn:active,
    .addr-m-btn.is-active,
    .addr-m-btn.is-focus{
      background-color: #744DFE !important;
      border-color: #744DFE !important;
      color: #fff !important;
    }

    /* 两个筛选一行：小区+楼栋 / 单元+房间 */
    .addr-m-grid{
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      width: 100%;
      margin-bottom: 6px;
    }
    .addr-m-cell{
      margin-left: 0px !important;
      margin-top: 0px !important;
      padding: 0px;
      min-width: 0;
    }
    .addr-m-cell ::v-deep .el-form-item__label{
      display: none !important;
    }
    .addr-m-cell ::v-deep .el-form-item__content{
      margin-left: 0 !important;
      width: 100%;
    }
    .addr-m-cell .el-select{
      width: 100% !important;
    }
    .addr-m-cell ::v-deep .el-input__inner{
      height: 40px;
      line-height: 40px;
      font-size: 16px !important;
      padding: 0 10px;
    }

    /* 手机端不显示底部大按钮（手机端用搜索行按钮即可） */
    .addr-desktop .elfomobtn,
    .addr-mobile .elfomobtn{
      display: none;
    }
  }
</style>

<!-- 下拉层挂到 body 时 scoped 样式无法命中，单独用全局类（仅小屏 + 本组件 popper-class） -->
<style lang="less">
@media (max-width: 768px) {
  .addr-m-select-popper.el-select-dropdown {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    pointer-events: auto;
  }
  .addr-m-select-popper .el-select-dropdown__item {
    font-size: 16px !important;
    min-height: 40px;
    line-height: 40px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
  }
}
</style>
